<template>
  <div>
    <header class="nav-bars" :class="{ scrolled: scrolled }">
      <div class="nav-logo">
        <div class="logo-icon"><img src="../../public/imgs/logos.png" alt="暖心日用百货" />
        </div>
        <div>
          <span>暖心日用百货</span>
          <div class="logo-sub">临海市 · 货源信息提交</div>
        </div>
      </div>
      <nav class="nav-links">
        <!--
    <a @click="scrollTo('features')">企业实力</a>-->
        <a @click="scrollTo('submit')">提交货源</a>
        <a @click="scrollTo('business')">商行信息</a>
      </nav>
      <button class="nav-cta" @click="scrollTo('submit')">立即提交</button>
      <button class="nav-hamburger" :class="{ active: mobileMenu }" @click="mobileMenu = !mobileMenu">
        <span></span><span></span><span></span>
      </button>
    </header>
    <div class="nav-mobile-menu" :class="{ show: mobileMenu }">
      <a @click="scrollTo('submit'); mobileMenu = false">提交货源</a>
      <a @click="scrollTo('business'); mobileMenu = false">商行信息</a>
    </div>

    <!-- Hero -->
    <section id="hero" class="hero">
      <span class="hero-tag">🏭 源头货源 · 一站提交</span>
      <h1>企业 · 工厂 · 电商库存下架 · 专柜实体店下架撤柜<br><span class="grad">尾货货源信息提交平台</span></h1>
      <p class="sub">无论您是工厂清仓、电商下架库存还是专柜撤柜清产品回收，提交货源信息即可获得专业评估与现金报价。照片、地址、联系方式一键提交，源头直收无缝对接。</p>
      <div class="hero-stats">
        <div class="hero-stat">
          <div class="hs-num">{{ stats.factorys }}+</div>
          <div class="hs-label">合作工厂</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">{{ stats.brands }}+</div>
          <div class="hs-label">品牌方</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">{{ stats.cities }}+</div>
          <div class="hs-label">覆盖城市</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">{{ stats.submissions }}</div>
          <div class="hs-label">已提交信息</div>
        </div>
      </div>
    </section>

    <!-- Features -->
    <section id="features" class="section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">源头直收</span>
        <h2>企业 · 工厂 · 电商库存下架 · <span class="grad">专柜实体店下架撤柜</span></h2>
        <p>打通源头到终端全链路，电商下架清库存、专柜撤柜一站式产品回收，让每一批尾货都能快速变现</p>
      </div>
      <div class="feature-grid">
        <div class="feature-card animate__animated animate__fadeInUp" style="animation-delay:.1s">
          <div class="feature-icon green">🏢</div>
          <h3>企业回收服务</h3>
          <p>面向品牌方、贸易公司、电商平台，提供退单/滞销/临期商品的专业回收服务。</p>
          <ul class="feature-list">
            <li>品牌退单产品收购</li>
            <li>电商退货库存产品回收</li>
            <li>企业临期商品处理</li>
            <li>拿样检验 · 下单采购</li>
          </ul>
        </div>
        <div class="feature-card animate__animated animate__fadeInUp" style="animation-delay:.2s">
          <div class="feature-icon gold">🏭</div>
          <h3>工厂直采对接</h3>
          <p>直接对接源头工厂，换季积压、出口尾单、残次品等采购下单打包回收解决方案。</p>
          <ul class="feature-list">
            <li>换季库存产品回收</li>
            <li>出口尾单产品回收</li>
            <li>工厂微残产品处理</li>
            <li>上门验货 · 拿样检验</li>
          </ul>
        </div>
        <div class="feature-card animate__animated animate__fadeInUp" style="animation-delay:.3s">
          <div class="feature-icon coral">📦</div>
          <h3>电商库存下架</h3>
          <p>面向电商平台退单滞销、季节性下架、库存积压商品，采购下单打包回收服务。</p>
          <ul class="feature-list">
            <li>电商退单滞销产品回收</li>
            <li>季节性下架库存回收</li>
            <li>仓库积压产品回收</li>
            <li>线上下架 · 线下回收</li>
          </ul>
        </div>
        <div class="feature-card animate__animated animate__fadeInUp" style="animation-delay:.4s">
          <div class="feature-icon purple">🏷️</div>
          <h3>专柜实体店下架撤柜</h3>
          <p>面向商场专柜、实体门店下架撤柜清场，采购下单打包回收，搬运清运一站式搞定。</p>
          <ul class="feature-list">
            <li>商场专柜下架撤柜库存产品回收</li>
            <li>实体门店歇业库存产品回收</li>
            <li>实物库存产品回收</li>
            <li>拿样检验 · 下单采购</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Submit Form -->
    <section id="submit" class="section form-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">提交货源</span>
        <h2>填写货源信息 · <span class="grad">快速获取报价</span></h2>
        <p>提交后我们将在24小时内联系您，提供专业评估</p>
      </div>
      <div class="form-wrap animate__animated animate__fadeInUp">
        <!-- Type -->
        <div class="form-group">
          <label>货源类型 <span class="req">*</span></label>
          <div class="type-chips">
            <div class="type-chip" :class="{ active: t === activeType }" v-for="t in types" :key="t"
              @click="changeType(t)">{{ t
              }}</div>
          </div>
        </div>
        <!-- Name -->
        <div class="form-group">
          <label>联系人姓名 <span class="req">*</span></label>
          <input class="form-input" :class="{ invalid: errors.name }" v-model="form.name" placeholder="请输入您的姓名"
            maxlength="20">
          <div class="form-error" :class="{ show: errors.name }">{{ errors.name }}</div>
        </div>
        <div class="form-row">
          <!-- Phone -->
          <div class="form-group">
            <label>联系号码 <span class="req">*</span></label>
            <input class="form-input" :class="{ invalid: errors.phone }" v-model="form.phone" type="tel" maxlength="11"
              placeholder="请输入手机号码" @input="form.phone = form.phone.replace(/\D/g, '')">
            <div class="form-error" :class="{ show: errors.phone }">{{ errors.phone }}</div>
          </div>
          <!-- WeChat -->
          <div class="form-group">
            <label>微信号 <span class="req">*</span></label>
            <input class="form-input" :class="{ invalid: errors.wechat }" v-model="form.wechat" placeholder="请输入微信号"
              maxlength="30">
            <div class="form-error" :class="{ show: errors.wechat }">{{ errors.wechat }}</div>
          </div>
        </div>
        <!-- Address -->
        <div class="form-group">
          <label>货物地址 <span class="req">*</span></label>
          <input class="form-input" :class="{ invalid: errors.address }" v-model="form.address"
            placeholder="请输入详细地址（省市区+街道+门牌号）" maxlength="100">
          <div class="form-error" :class="{ show: errors.address }">{{ errors.address }}</div>
          <div class="hint">填写准确地址方便我们安排上门验货</div>
        </div>
        <!-- Message -->
        <div class="form-group">
          <label>货源描述留言 <span class="req">*</span></label>
          <textarea class="form-textarea" :class="{ invalid: errors.message }" v-model="form.message"
            placeholder="请描述货源详情：品类、数量、产品材质、产品执行标准、品质状况、期望价格等" maxlength="500"></textarea>
          <div class="hint" style="display:flex;justify-content:space-between">
            <span class="form-error" :class="{ show: errors.message }">{{ errors.message }}</span>
            <span>{{ form.message.length }}/500</span>
          </div>
        </div>
        <!-- Photos -->
        <div class="form-group">
          <label>货物照片 <span class="req">*</span></label>
          <div class="centers-images">
            <el-upload class="upload-demo" name="file" action="https://sosunlive.com/api/public/upload/image"
              :data="additionalData" :on-preview="handlePreview"
              :on-remove="(file, fileList, index) => { handleRemove(file, fileList, index) }" :file-list="fileList"
              :before-upload="beforeUpload" :headers="headers" :on-success="handleSuccess" list-type="picture"
              :limit="9" accept=".jpg,.png,.bmp">
              <el-button size="small" type="primary" style="padding: 9px 15px;">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
          </div>

        </div>
        <!-- Submit -->
        <button class="form-submit" :disabled="submitting" @click="submitForm">
          {{ submitting ? '提交中...' : '🚀 提交货源信息' }}
        </button>
      </div>
    </section>

    <!-- Business Profile -->
    <section id="business" class="section biz-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">商行资质</span>
        <h2>临海市暖心日用百货商行 · <span class="grad">个体工商户</span></h2>
        <p>6年老店 · 诚信合法经营 · 货源信息真实可追溯</p>
      </div>
      <div class="biz-wrap">
        <div class="biz-card animate__animated animate__fadeInUp">
          <div class="biz-seal">
            <img src="../../public/imgs/logos.png" alt="临海市暖心日用百货商行" />
          </div>
          <div class="biz-info">
            <h3>临海市暖心日用百货商行</h3>
            <p class="biz-sub">个体工商户 · 日用百货批发零售 · 尾货回收变现</p>
            <div class="biz-badges">
              <span class="biz-badge gold">🏆 6年老店</span>
              <span class="biz-badge green">✓ 诚信合法经营</span>
              <span class="biz-badge blue">📋 营业执照已公示</span>
              <span class="biz-badge coral">🛡️ 实地认证商行</span>
            </div>
            <div class="biz-meta">
              <div class="biz-meta-item">📍 <strong>浙江省临海市</strong></div>
              <div class="biz-meta-item">📅 <strong>成立2019年</strong></div>
              <div class="biz-meta-item">🏷️ <strong>个体工商户</strong></div>
              <div class="biz-meta-item">📞 <strong>17005865066</strong></div>
            </div>
          </div>
        </div>
        <div class="biz-trust-row animate__animated animate__fadeInUp" style="animation-delay:.15s">
          <div class="biz-trust">
            <div class="bt-icon">📅</div>
            <div class="bt-num">6<span style="font-size:14px">年</span></div>
            <div class="bt-label">老店经营</div>
          </div>
          <div class="biz-trust">
            <div class="bt-icon">📦</div>
            <div class="bt-num">3200<span style="font-size:14px">+</span></div>
            <div class="bt-label">累计回收批次</div>
          </div>
          <div class="biz-trust">
            <div class="bt-icon">🤝</div>
            <div class="bt-num">86<span style="font-size:14px">+</span></div>
            <div class="bt-label">长期合作方</div>
          </div>
          <div class="biz-trust">
            <div class="bt-icon">⭐</div>
            <div class="bt-num">98<span style="font-size:14px">%</span></div>
            <div class="bt-label">客户满意度</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-top">
          <div class="footer-col-brand">
            <div class="footer-brand">
              <div class="logo-icon"><img src="../../public/imgs/logos.png" alt="临海市暖心日用百货商行" /></div>
              <span>临海市暖心日用百货商行</span>
            </div>
            <p class="footer-desc">专注企业尾货回收与货源变现，源头直收、精准收购、现金结算。助力工厂清仓变现，电商库存下架清仓、专柜实体店下架撤柜一站式清场。</p>
            <div class="footer-tags">
              <span>🏆 6年老店</span>
              <span>✓ 诚信经营</span>
              <span>📋 营业执照</span>
              <span>🛡️ 实地认证</span>
            </div>
          </div>
          <div class="footer-col-links">
            <h4>快速导航</h4>
            <!--
        <a @click="scrollTo('features')">企业实力</a>-->
            <a @click="scrollTo('submit')">提交货源</a>
            <a @click="scrollTo('business')">商行信息</a>
          </div>
          <div class="footer-col-contact">
            <h4>联系我们</h4>
            <div class="footer-contact">
              <p>🏪 <strong>临海市暖心日用百货商行</strong></p>
              <!--
          <p>📞 <strong>400-888-6688</strong></p>-->
              <p>📱 <strong><a style="display: inline-block;color: rgba(255,255,255,.9);"
                    href="tel:17005865066">17005865066</a></strong></strong></p>
              <p>📍 浙江省临海市 · 全国上门验货</p>
              <p>🕐 周一至周日 8:00-22:00</p>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 临海市暖心日用百货商行 · 尾货货源信息提交平台 浙ICP备17001033号-1 浙公网安备33108202000960号 保留所有权利</p>
          <p class="fb-slogan">💡 让每一件尾货都有价值</p>
        </div>
      </div>
    </footer>

    <!-- Toast -->
    <div class="toast" :class="{ show: toast.show }">
      <span>{{ toast.icon }}</span>
      <span>{{ toast.text }}</span>
    </div>
    <el-dialog :visible.sync="dialogVisible" :width="width">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import * as imageConversion from 'image-conversion'
export default {
  name: "Submit",
  data() {
    return {
      id: this.$route.params.id,
      dialogVisible: false,
      dialogImageUrl: '',
      scrolled: false,
      width: '50%',
      activeType: '其他',
      mobileMenu: false,
      submitting: false,
      additionalData: {},
      headers: {},
      fileList: [],
      types: ['服装鞋帽', '日用百货', '食品零食', '电子数码', '家居家电', '盲盒解压潮玩', '箱包皮具', '其他'],
      form: {
        type: '8',
        name: '',
        phone: '',
        wechat: '',
        address: '',
        message: '',
        image_input: []
      },
      errors: {},
      toast: { show: false, icon: '', text: '' },
      stats: { factorys: 320, brands: 86, cities: 45, submissions: 128 }
    };
  },
  components: {

  },
  created() {
    if (window.screen.width > 1280) {
      this.width = "40%"
    } else {
      this.width = "95%";
    }

  },
  mounted: function () {
    var self = this;
    window.addEventListener('scroll', this.handleScroll);
    if (this.$route.params.id == '1') {
      this.scrollTo('submit')
    } else {
      this.scrollTo('business')
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    changeType(t) {
      let self = this
      if (t == '服装鞋帽') {
        self.form.type = 1
        self.activeType = '服装鞋帽'
      } else if (t == '日用百货') {
        self.form.type = 2
        self.activeType = '日用百货'
      } else if (t == '食品零食') {
        self.form.type = 3
        self.activeType = '食品零食'
      } else if (t == '电子数码') {
        self.form.type = 4
        self.activeType = '电子数码'
      } else if (t == '家居家电') {
        self.form.type = 5
        self.activeType = '家居家电'
      } else if (t == '盲盒解压潮玩') {
        self.form.type = 6
        self.activeType = '盲盒解压潮玩'
      } else if (t == '箱包皮具') {
        self.form.type = 7
        self.activeType = '箱包皮具'
      } else if (t == '其他') {
        self.form.type = 8
        self.activeType = '其他'
      }
    },
    beforeUpload(file) {
      let self = this
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isImage = types.includes(file.type);
      // const isLtSize = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        //this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
        this.showToast('⚠️', '上传图片只能是 JPG、JPEG、PNG 格式!');
        return false;
      }
      //图片压缩插件
      return new Promise((resolve) => {
        imageConversion.compressAccurately(file, 400).then(res => {
          let files = new File([res], file.name, { type: file.type });
          resolve(files)
        });
      })
      /**
      let isRightSize = file.size / (1024 * 500) < 0.5;
      if (!isRightSize) {
        this.$message.error(`文件不要超过500KB`);
        return false;
      }
      if(self.fileList.length>9){
        self.$message.error(`最多上传9张图片`);
        return false
      }**/
    },
    handleSuccess(res, file, fileList) {
      if (res.status == 200) {
        this.fileList.push({
          name: res.data.name,
          fileId: res.data.url,
          url: res.data.url,
        });
        this.$emit("input", this.fileList);
      } else {
        fileList.filter((o) => o.uid != file.uid);
        this.$emit("input", this.fileList);
        this.showToast('⚠️', res.msg);
        //this.$message({ message: res.msg, type: "error", duration: 1500 });
      }
    },
    handleRemove(file, fileList, index) {
      let self = this
      self.fileList.splice(index, 1)
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleScroll: function () {
      this.scrolled = window.scrollY > 20;
    },
    scrollTo: function (id) {
      var el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      this.mobileMenu = false;
    },
    validate: function () {
      var e = {};
      if (!this.form.name.trim()) e.name = '请输入联系人姓名';
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) e.phone = '请输入正确的手机号码';
      if (!this.form.wechat.trim()) e.wechat = '请输入微信号';
      else if (this.form.wechat.trim().length < 2) e.wechat = '微信号格式不正确';
      if (!this.form.address.trim()) e.address = '请输入货物地址';
      else if (this.form.address.trim().length < 5) e.address = '地址过于简短，请填写详细地址';
      if (!this.form.message.trim()) e.message = '请描述货源详情';
      else if (this.form.message.trim().length < 1) e.message = '描述过于简短，请至少输入10个字';
      if (this.fileList.length === 0) e.photos = '请至少上传一张货物照片';
      this.errors = e;
      return Object.keys(e).length === 0;
    },
    submitForm: function () {
      if (!this.validate()) {
        this.showToast('⚠️', '请完善必填信息后提交');
        return;
      }
      this.submitting = true;
      var self = this;
      let images = ''
      if (self.fileList.length > 0) {
        for (let a = self.fileList.length - 1; a >= 0; a--) {
          images = '"' + self.fileList[a].url + '"' + "," + images;
        }
      }
      images = images.substring(0, images.length - 1);
      images = '[' + images + ']'
      self.$api.mall.submitMessage({
        image_input: images,
        nickname: self.form.name,
        wxcode: self.form.wechat,
        address: self.form.address,
        message: self.form.message,
        phone: self.form.phone,
        type: self.form.type,
      }).then((res) => {
        self.showToast('✅', '货源信息提交成功！我们将尽快联系您');
        self.resetForm();
        self.submitting = false;
      });
      /**
      setTimeout(function () {
        self.resetForm();
        self.submitting = false;
        self.showToast('✅', '货源信息提交成功！我们将尽快联系您');
      }, 800);
      **/
    },
    resetForm: function () {
      this.form = {
        type: '8',
        name: '',
        phone: '',
        wechat: '',
        address: '',
        message: '',
      };
      this.fileList = []
      this.errors = {};
    },
    showToast: function (icon, text) {
      this.toast = { show: true, icon: icon, text: text };
      var self = this;
      setTimeout(function () { self.toast.show = false; }, 2800);
    }
  },
};
</script>
<style lang="scss" scoped>
:root {
  --primary: #2d8f6f;
  --primary-light: #4caf85;
  --deep: #14623a;
  --gold: #d4a745;
  --coral: #e85d4e;
  --bg: #f5f9f7;
  --card-bg: #fff;
  --text: #2a3340;
  --text-light: #5a6878;
  --text-lighter: #9ba8b5;
  --border: #e4ede9;
  --radius: 18px;
  --shadow: 0 4px 20px rgba(20, 70, 58, .06);
  --shadow-lg: 0 12px 44px rgba(20, 70, 58, .12)
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: var(--bg);
  color: var(--text);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased
}

* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
}

a {
  cursor: pointer;
  text-decoration: none
}

img {
  max-width: 100%
}

.grad {
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent
}

/* ── Scrollbar ── */
::-webkit-scrollbar {
  width: 7px;
  height: 7px
}

::-webkit-scrollbar-track {
  background: transparent
}

::-webkit-scrollbar-thumb {
  background: rgba(45, 143, 111, .28);
  border-radius: 20px;
  border: 2px solid transparent;
  background-clip: content-box;
  transition: background .2s
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(45, 143, 111, .45);
  background-clip: content-box
}

::-webkit-scrollbar-thumb:active {
  background: rgba(45, 143, 111, .6);
  background-clip: content-box
}

::-webkit-scrollbar-corner {
  background: transparent
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(45, 143, 111, .28) transparent
}

.centers-images {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  margin: 0px auto;
}

/* ── Nav ── */
.nav-bars {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: rgba(255, 255, 255, .92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  transition: box-shadow .3s
}

.nav-bars.scrolled {
  box-shadow: 0 2px 12px rgba(20, 70, 58, .06)
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 800;
  color: var(--deep)
}

.nav-logo .logo-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(20, 70, 58, .15);
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid var(--border)
}

.nav-logo .logo-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block
}

.nav-logo .logo-sub {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-lighter)
}

.nav-links {
  display: flex;
  gap: 28px;
  align-items: center
}

.nav-links a {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-light);
  transition: color .2s;
  position: relative
}

.nav-links a:hover {
  color: var(--primary)
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary);
  border-radius: 1px;
  transition: width .25s
}

.nav-links a:hover::after {
  width: 100%
}

.nav-cta {
  padding: 8px 20px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all .25s;
  background: linear-gradient(135deg, var(--primary), var(--deep));
  color: #fff;
  box-shadow: 0 4px 14px rgba(45, 143, 111, .25)
}

.nav-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(45, 143, 111, .35)
}

.nav-hamburger {
  display: none;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px
}

.nav-hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--deep);
  border-radius: 2px;
  transition: all .3s
}

.nav-hamburger.active span:nth-child(1) {
  transform: translateY(7px) rotate(45deg)
}

.nav-hamburger.active span:nth-child(2) {
  opacity: 0
}

.nav-hamburger.active span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg)
}

.nav-mobile-menu {
  display: none;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  background: #fff;
  border-bottom: 1px solid var(--border);
  padding: 16px 24px;
  flex-direction: column;
  gap: 4px;
  z-index: 99;
  box-shadow: 0 8px 24px rgba(20, 70, 58, .08)
}

.nav-mobile-menu.show {
  display: flex
}

.nav-mobile-menu a {
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  border-radius: 10px;
  transition: background .2s
}

.nav-mobile-menu a:hover {
  background: var(--bg)
}

/* ── Hero ── */
.hero {
  padding: 96px 40px 48px;
  background: linear-gradient(180deg, #e8f5ef, var(--bg));
  text-align: center
}

.hero-tag {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  background: rgba(45, 143, 111, .1);
  color: var(--primary);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px
}

.hero h1 {
  font-size: 38px;
  font-weight: 900;
  color: var(--deep);
  margin-bottom: 14px;
  line-height: 1.3
}

.hero h1 .grad {
  display: inline
}

.hero p.sub {
  font-size: 16px;
  color: var(--text-light);
  max-width: 640px;
  margin: 0 auto 24px
}

.hero-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 24px 0;
  flex-wrap: wrap
}

.hero-stat {
  text-align: center
}

.hero-stat .hs-num {
  font-size: 30px;
  font-weight: 900;
  color: var(--primary)
}

.hero-stat .hs-label {
  font-size: 13px;
  color: var(--text-lighter);
  margin-top: 2px
}

/* ── Section ── */
.section {
  padding: 60px 40px;
  max-width: 1200px;
  margin: 0 auto
}

.section-head {
  text-align: center;
  margin-bottom: 40px
}

.section-head .sh-tag {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 16px;
  background: rgba(45, 143, 111, .08);
  color: var(--primary);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px
}

.section-head h2 {
  font-size: 28px;
  font-weight: 900;
  color: var(--deep);
  margin-bottom: 8px
}

.section-head p {
  font-size: 15px;
  color: var(--text-light)
}

/* ── Feature Cards (企业/工厂/电商库存下架/专柜实体店下架撤柜) ── */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px
}

.feature-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px 22px;
  transition: all .35s;
  position: relative;
  overflow: hidden
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary), var(--gold));
  opacity: 0;
  transition: opacity .3s
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(45, 143, 111, .2)
}

.feature-card:hover::before {
  opacity: 1
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 18px
}

.feature-icon.green {
  background: linear-gradient(135deg, rgba(45, 143, 111, .12), rgba(45, 143, 111, .04))
}

.feature-icon.gold {
  background: linear-gradient(135deg, rgba(212, 167, 69, .12), rgba(212, 167, 69, .04))
}

.feature-icon.coral {
  background: linear-gradient(135deg, rgba(232, 93, 78, .12), rgba(232, 93, 78, .04))
}

.feature-icon.purple {
  background: linear-gradient(135deg, rgba(139, 92, 246, .12), rgba(139, 92, 246, .04))
}

.feature-card h3 {
  font-size: 19px;
  font-weight: 800;
  color: var(--deep);
  margin-bottom: 10px
}

.feature-card>p {
  font-size: 14px;
  color: var(--text-light);
  margin-bottom: 16px;
  line-height: 1.7
}

.feature-list {
  list-style: none
}

.feature-list li {
  font-size: 13px;
  color: var(--text-light);
  padding: 6px 0 6px 24px;
  position: relative
}

.feature-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  top: 6px;
  color: var(--primary);
  font-weight: 800
}

/* ── Form Section ── */
.form-section {
  background: linear-gradient(180deg, var(--bg), #e8f5ef)
}

.form-wrap {
  max-width: 720px;
  margin: 0 auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 40px;
  box-shadow: var(--shadow-lg)
}

.form-group {
  margin-bottom: 24px
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: var(--deep);
  margin-bottom: 8px
}

.form-group label .req {
  color: var(--coral);
  margin-left: 2px
}

.form-group .hint {
  font-size: 12px;
  color: var(--text-lighter);
  margin-top: 4px
}

.form-input,
.form-textarea,
.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid var(--border);
  border-radius: 12px;
  font-size: 15px;
  color: var(--text);
  outline: none;
  transition: border-color .25s, box-shadow .25s;
  background: var(--bg);
  font-family: inherit
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(45, 143, 111, .1)
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: var(--text-lighter)
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.6
}

.form-row {
  display: flex;
  gap: 16px
}

.form-row .form-group {
  flex: 1
}

.form-error {
  font-size: 12px;
  color: var(--coral);
  margin-top: 4px;
  display: none
}

.form-error.show {
  display: block
}

.form-input.invalid,
.form-textarea.invalid {
  border-color: var(--coral)
}


/* ── Type Chips ── */
.type-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap
}

.type-chip {
  padding: 8px 16px;
  border-radius: 10px;
  border: 1.5px solid var(--border);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-light);
  cursor: pointer;
  transition: all .25s;
  background: var(--bg)
}

.type-chip:hover {
  border-color: var(--primary-light);
  color: var(--primary)
}

.type-chip.active {
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 3px 10px rgba(45, 143, 111, .25)
}

/* ── Submit Button ── */
.form-submit {
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  border: none;
  font-size: 17px;
  font-weight: 800;
  cursor: pointer;
  transition: all .25s;
  margin-top: 8px;
  background: linear-gradient(135deg, var(--primary), var(--deep));
  color: #fff;
  box-shadow: 0 6px 20px rgba(20, 70, 58, .2)
}

.form-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 26px rgba(20, 70, 58, .3)
}

.form-submit:active {
  transform: translateY(0)
}

.form-submit:disabled {
  background: var(--border);
  color: var(--text-lighter);
  cursor: not-allowed;
  box-shadow: none;
  transform: none
}

/* ── Success Toast ── */
.toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);
  background: var(--primary);
  color: #fff;
  padding: 14px 28px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  box-shadow: 0 8px 28px rgba(45, 143, 111, .35);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all .35s;
  display: flex;
  align-items: center;
  gap: 10px
}

.toast.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0)
}

/* ── Business Profile (个体户商行信息) ── */
.biz-section {
  background: linear-gradient(180deg, #e8f5ef, var(--bg))
}

.biz-wrap {
  max-width: 900px;
  margin: 0 auto
}

.biz-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 24px;
  padding: 40px;
  box-shadow: var(--shadow-lg);
  display: flex;
  gap: 32px;
  align-items: center;
  transition: all .35s
}

.biz-card:hover {
  box-shadow: 0 16px 48px rgba(20, 70, 58, .16)
}

.biz-seal {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  background: #fff;
  box-shadow: 0 8px 24px rgba(45, 143, 111, .3);
  padding: 8px;
  border: 1px solid var(--border)
}

.biz-seal::before {
  content: '';
  position: absolute;
  inset: 6px;
  border: 2px solid rgba(45, 143, 111, .15);
  border-radius: 50%
}

.biz-seal img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 50%;
  position: relative;
  z-index: 1
}

.biz-info {
  flex: 1;
  min-width: 0
}

.biz-info h3 {
  font-size: 22px;
  font-weight: 900;
  color: var(--deep);
  margin-bottom: 6px
}

.biz-info .biz-sub {
  font-size: 14px;
  color: var(--text-light);
  margin-bottom: 16px
}

.biz-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px
}

.biz-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700
}

.biz-badge.gold {
  background: linear-gradient(135deg, rgba(212, 167, 69, .12), rgba(212, 167, 69, .04));
  color: #b8902f
}

.biz-badge.green {
  background: linear-gradient(135deg, rgba(45, 143, 111, .12), rgba(45, 143, 111, .04));
  color: var(--primary)
}

.biz-badge.coral {
  background: linear-gradient(135deg, rgba(232, 93, 78, .12), rgba(232, 93, 78, .04));
  color: #c94a3e
}

.biz-badge.blue {
  background: linear-gradient(135deg, rgba(59, 130, 246, .12), rgba(59, 130, 246, .04));
  color: #2563eb
}

.biz-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px
}

.biz-meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-light)
}

.biz-meta-item strong {
  color: var(--deep);
  font-weight: 700
}

.biz-trust-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 16px
}

.biz-trust {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 22px 12px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 16px;
  transition: all .35s;
  position: relative;
  overflow: hidden
}

.biz-trust::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary), var(--primary-light), var(--gold));
  opacity: .6;
  transition: opacity .3s
}

.biz-trust:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow);
  border-color: rgba(45, 143, 111, .18)
}

.biz-trust:hover::before {
  opacity: 1
}

.biz-trust .bt-icon {
  font-size: 28px;
  margin-bottom: 8px;
  line-height: 1
}

.biz-trust .bt-num {
  font-size: 24px;
  font-weight: 900;
  color: var(--primary);
  line-height: 1.1
}

.biz-trust .bt-label {
  font-size: 12px;
  color: var(--text-lighter);
  margin-top: 4px
}

@media(min-width:769px) {
  .biz-trust:nth-child(1)::before {
    background: linear-gradient(90deg, var(--gold), #e8c668)
  }

  .biz-trust:nth-child(2)::before {
    background: linear-gradient(90deg, var(--primary), var(--primary-light))
  }

  .biz-trust:nth-child(3)::before {
    background: linear-gradient(90deg, #8b5cf6, #6366f1)
  }

  .biz-trust:nth-child(4)::before {
    background: linear-gradient(90deg, var(--coral), #f5755e)
  }
}

/* ── Footer ── */
.site-footer {
  background: var(--deep);
  color: rgba(255, 255, 255, .85);
  padding: 44px 40px 20px;
  position: relative
}

.site-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary), var(--primary-light), var(--gold), var(--coral))
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto
}

.footer-top {
  display: grid;
  grid-template-columns: 1.5fr .8fr 1.2fr;
  gap: 40px;
  margin-bottom: 28px
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 17px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px
}

.footer-brand .logo-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, .2);
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15)
}

.footer-brand .logo-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block
}

.footer-desc {
  font-size: 13px;
  line-height: 1.8;
  max-width: 400px;
  color: rgba(255, 255, 255, .6);
  margin-bottom: 14px
}

.footer-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap
}

.footer-tags span {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .08);
  color: rgba(255, 255, 255, .65);
  border: 1px solid rgba(255, 255, 255, .06)
}

.footer-col-links h4,
.footer-col-contact h4 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 14px;
  position: relative;
  padding-bottom: 8px
}

.footer-col-links h4::after,
.footer-col-contact h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  background: linear-gradient(90deg, var(--primary-light), var(--gold))
}

.footer-col-links a {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, .6);
  padding: 7px 0;
  transition: color .2s, padding-left .2s;
  cursor: pointer
}

.footer-col-links a:hover {
  color: #fff;
  padding-left: 6px
}

.footer-contact p {
  font-size: 13px;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, .6);
  display: flex;
  align-items: flex-start;
  gap: 8px
}

.footer-contact p strong {
  color: rgba(255, 255, 255, .9);
  font-weight: 600
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, .1);
  font-size: 12px;
  color: rgba(255, 255, 255, .45)
}

.footer-bottom .fb-slogan {
  display: flex;
  align-items: center;
  gap: 6px
}

/* ── Responsive ── */
@media(max-width:1024px) {
  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 680px;
    margin: 0 auto
  }

  .hero h1 {
    font-size: 30px
  }
}

@media(max-width:768px) {
  .nav-links {
    display: none
  }

  .nav-cta {
    display: none
  }

  .nav-hamburger {
    display: flex
  }

  .nav-bars {
    padding: 0 16px;
    height: 56px
  }

  .section {
    padding: 40px 16px
  }

  .hero {
    padding: 76px 16px 32px
  }

  .hero h1 {
    font-size: 24px
  }

  .hero p.sub {
    font-size: 14px
  }

  .hero-stats {
    gap: 20px
  }

  .hero-stat .hs-num {
    font-size: 22px
  }

  .section-head h2 {
    font-size: 22px
  }

  .feature-grid {
    grid-template-columns: 1fr;
    max-width: 420px
  }

  .form-wrap {
    padding: 24px 18px
  }

  .form-row {
    flex-direction: column;
    gap: 0
  }

  .biz-card {
    flex-direction: column;
    text-align: center;
    padding: 32px 24px
  }

  .biz-seal {
    margin: 0 auto
  }

  .biz-info {
    text-align: center
  }

  .biz-badges {
    justify-content: center
  }

  .biz-meta {
    justify-content: center
  }

  .biz-trust-row {
    grid-template-columns: repeat(2, 1fr)
  }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 28px
  }

  .footer-bottom {
    justify-content: center;
    text-align: center
  }
}

@media(max-width:480px) {
  .hero h1 {
    font-size: 20px
  }

  .hero-stats {
    gap: 14px
  }

  .hero-stat .hs-num {
    font-size: 18px
  }

  .hero-stat .hs-label {
    font-size: 10px
  }

  .section-head h2 {
    font-size: 18px
  }

  .feature-card {
    padding: 24px 18px
  }

  .feature-icon {
    width: 52px;
    height: 52px;
    font-size: 24px;
    border-radius: 14px
  }

  .form-wrap {
    padding: 20px 14px;
    border-radius: 16px
  }

  .photo-slot {
    width: 80px;
    height: 80px
  }

  .biz-card {
    padding: 24px 18px
  }

  .biz-seal {
    width: 90px;
    height: 90px
  }

  .biz-seal .seal-icon {
    font-size: 28px
  }

  .biz-info h3 {
    font-size: 18px
  }

  .biz-trust {
    padding: 16px 10px
  }

  .biz-trust .bt-icon {
    font-size: 24px
  }

  .biz-trust .bt-num {
    font-size: 20px
  }

  .site-footer {
    padding: 32px 16px 16px
  }

  .footer-top {
    gap: 20px
  }

  .footer-tags span {
    font-size: 10px;
    padding: 3px 8px
  }
}
</style>